import axios from 'axios'
import {
    globalConfig,
} from '@/config'

const localState = {
    data: {},
    master: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
    },
    newMaster: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
    },
    masterFormData: {},
    services: [],
    formDataImg: {},
    request: {
        state: ' ',
        message: '',
    },
}
const actions = {
    getMastersData({
        dispatch,
        commit,
    }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .get('/masters', window.requestConfig)
                    .then((res) => {
                        commit('addAllServices', {
                            data: res.data.data,
                        })
                        commit('mastersData', {
                            data: res.data.data,
                        })
                        resolve()
                    })
                    .catch(() => {
                        // log err
                        reject()
                    })
            })
        })
    },
    getMaster({
        state,
        dispatch,
    }, {
        id,
        type = 'engineers',
    }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .get(`/${type}/${id}`, window.requestConfig)
                    .then((res) => {
                        state.master = res.data
                        state.request.state = ''
                        state.request.message = ''
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        }
                        reject()
                    })
            })
        })
    },
    addMaster({
        state,
        dispatch,
        commit,
    }) {
        return new Promise((resolve, reject) => {
            commit('masterForm', {
                data: state.newMaster,
            })

            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .post('/masters', state.masterFormData, window.requestConfig)
                    .then((res) => {
                        dispatch('getMastersData')
                        if (state.newMaster.big_image) {
                            dispatch('updateMasterAvatar', {
                                id: res.data.id,
                                data: state.formDataImg,
                            })
                        }
                        state.request.state = 'success'
                        setTimeout(() => {
                            commit('udpateObject', {
                                data: 'newMaster',
                            })
                            commit('udpateObject', {
                                data: 'request',
                            })
                        }, 1000)
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
    editMaster({
        state,
        dispatch,
        commit,
    }, id) {
        return new Promise((resolve, reject) => {
            // state.request.state = 'loading';
            commit('masterForm', {
                data: state.master,
            })
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .put(`/masters/${id}`, state.masterFormData, window.requestConfig)
                    .then(() => {
                        dispatch('getMastersData')
                        state.request.state = 'success'
                        setTimeout(() => {
                            commit('udpateObject', {
                                data: 'master',
                            })
                            commit('udpateObject', {
                                data: 'request',
                            })
                        }, 1000)
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
    updateMasterAvatar({
        state,
        dispatch,
    }, {
        id,
        data,
    }) {
        state.formDataImg = data
        if (id) {
            dispatch('checkAuth').then((token) => {
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'multipart/form-data',
                }
                axios
                    .post(
                        `${globalConfig.baseUrl}/masters/${id}/image`,
                        data,
                        headers,
                    )
                    .then(() => {
                        dispatch('getMastersData')
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        }
                    })
            })
        }
    },
    deleteMaster({
        dispatch,
    }, id) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .delete(`/masters/${id}`, window.requestConfig)
                    .then(() => {
                        dispatch('getMastersData')
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        }
                        reject()
                    })
            })
        })
    },
}
const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    addAllServices(state, {
        data,
    }) {
        const services = []
        data.forEach((el) => {
            services.push(el.service.name)
        })
        // }
        state.services = services
    },
    mastersData(state, {
        data,
    }) {
        // let mastersData = [];
        // let char = '';
        // for (var key in data) {
        // data[key].forEach(el => {
        // if (char.toLowerCase() !== key.toLowerCase()) {
        // el.char = key;
        // char = key;
        // }
        // mastersData.push(el);
        // })
        // }
        state.data = data
    },
    masterForm(state, {
        data,
    }) {
        const masterData = {
            first_name: data.first_name,
            last_name: data.last_name,
            service_id: data.service.id,
            phone: data.phone,
            email: data.email,
            description: data.description,
            password: data.password,
        }
        if (data.password === false) {
            delete masterData.password
        }
        state.masterFormData = masterData
    },
    setAvatarMaster(state, {
        data,
        type,
    }) {
        if (type === 'add') {
            state.newMaster.big_image = data
            state.newMaster.small_image = data
        } else {
            state.master.big_image = data
            state.master.small_image = data
        }
    },
    udpateObject(state, {
        data,
    }) {
        for (const key in state[data]) {
            state[data][key] = ''
        }
    },
}

const getters = {
    getMasterById: (state) => state.master,
    getMasters: (state) => state.data,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
